export default __webpack_public_path__ + "static/media/iconbutton-multiplewindows-dark-sidebar-disabled.dcf1ef3a.svg";